export const BRAND_LOGO =
  'https://public.readdy.ai/ai/img_res/22bc58f3-7d70-48ff-8c89-aab3b9a32fce.png';

export const BRAND_MARK =
  'https://public.readdy.ai/ai/img_res/edited_b404f1fb54e892c9b86c4c75aa16c05d_213d047a.jpg';

// Outdoor-Portrait (weißes Hemd, Natur) – Hauptbild „Über mich"
export const PHOTO_PORTRAIT =
  'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/87fbc731-28d1-4be1-be32-e367b9fe3c12_compressed_818E8E98-0B39-4450-B0EE-0C215D73F728.webp';

// Action-Shot (Blazer, Flipchart) – Praxisbeispiele
export const PHOTO_WORKING =
  'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/86d12be7-9304-4d3b-a7d8-c1a58534efd4_compressed_BBF557EA-10C6-4B74-B3BA-932DC10A6B10.webp';

// Home-Portrait (Wohnzimmer, Tasse) – zweites Portrait
export const PHOTO_HEADSHOT =
  'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/04c72cee-aee2-44b2-a0d6-afddef8d0b34_compressed_A382F220-BC75-47CA-87F6-CBAFEE6776D4.webp';